import React, { createContext, useContext } from 'react';
import { User } from 'firebase/auth';
import { ExamData } from '../../utils/examData';

// Shared state + handlers that the per-region tab components need. Lets tab UIs
// be extracted out of the MainApp monolith and consume this via useExamTab()
// instead of threading a dozen props through each one.
export interface ExamTabContextValue {
  examData: ExamData | null;
  setExamData: React.Dispatch<React.SetStateAction<ExamData | null>>;
  user: User | null;
  userProfile: any;
  startManualSession: () => Promise<boolean>;
  setShowAuthModal: (show: boolean) => void;
  copyRegionValues: (region: string, direction: 'left_to_right' | 'right_to_left') => void;
  handleClearRegion: (region: string) => void;
  clearConfirmRegion: string | null;
  fillNormalValues: (region: string) => void | Promise<void>;
  handSection: string;
  setHandSection: (section: string) => void;
}

const ExamTabContext = createContext<ExamTabContextValue | null>(null);

export const ExamTabProvider = ExamTabContext.Provider;

export const useExamTab = (): ExamTabContextValue => {
  const ctx = useContext(ExamTabContext);
  if (!ctx) {
    throw new Error('useExamTab must be used within an ExamTabProvider');
  }
  return ctx;
};
